<template>
    <v-container>
        <v-card class="card">
            <v-card-text>
                <v-layout>
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <div v-show="filter_open" class="pa-5">
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                        v-model="filtro.email_destinatario"
                                        label="E-mail do Destinatário:"
                                        placeholder="Digite o e-mail do Destinatário"
                                        outlined
                                        maxlength="255"
                                />
                            </v-col>
                            <v-col cols="6">
                                <Autocomplete
                                        v-model="filtro.acao_analise_credito"
                                        :items="TiposAnaliseCredito"
                                        label="Ação Análise de Crédito:"
                                        placeholder="Selecione a ação de Análise de Crédito"
                                        item-text="label"
                                        item-value="value"
                                        multiple
                                        outlined
                                        chips
                                        deletable-chips
                                />
                            </v-col>
                            <v-col cols="6">
                                <Autocomplete
                                        v-model="filtro.tipo_grupo"
                                        :items="TiposGrupoFiltro"
                                        label="Tipo do Grupo:"
                                        placeholder="Selecione o Tipo de Grupo"
                                        item-text="label"
                                        item-value="value"
                                        multiple
                                        outlined
                                        chips
                                        deletable-chips
                                />
                            </v-col>
                        </v-row>
                        <v-row class="justify-end">
                            <v-btn color="secondary" class="mr-4" @click="resetFilter">Limpar</v-btn>
                            <v-btn color="primary mr-n1" @click="filtrar">Filtrar</v-btn>
                        </v-row>
                    </div>
                </collapse-transition>
                <DataTable
                        :headers="headers"
                        :params="params"
                        :filter="custom_filter"
                        url="/painel/datatable/emails-analise-credito"
                >
                    <template v-slot:items="{item}">
                        <td class="text-center">
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                            color="primary"
                                            class="btn-acoes"
                                            v-bind="attrs"
                                            style="width: 52px;
                                               height: 48px;
                                               padding: 5px;
                                               margin: 10px;
                                               min-width: 48px;"
                                            v-on="on"
                                    >
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <v-list-item-title>Editar</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="confirmExcluir(item.id_cadastro)">
                                        <v-list-item-title>Excluir</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>{{ item.email_destinatario }}</td>
                        <td class="text-center">
                            <div class="tags-container">
                                <span
                                        v-for="(label, index) in item.tipo_grupo_labels"
                                        :key="index"
                                        class="tipo-grupo-background"
                                >
                                    {{ label }}
                                </span>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="tags-container">
                                <span
                                        v-for="(label, index) in item.acoes_analise_labels"
                                        :key="index"
                                        class="analise-background"
                                >
                                    {{ label }}
                                </span>
                            </div>
                        </td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { AlertTypes } from '@/plugins/alerts_types'
  import { alert, notification } from '@/plugins/helpers'
  import { TiposGrupoFiltro, TiposAnaliseCredito } from '@/plugins/constants'

  export default {
    name: 'ListagemEmailsAnaliseCredito',
    props: {
      atualizaListagem: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        filter_open: false,
        TiposGrupoFiltro,
        TiposAnaliseCredito,
        headers: [
          { text: 'Ações', value: '', align: 'center', sortable: false },
          { text: 'E-mail do Destinatário', value: 'email_destinatario' },
          { text: 'Tipo do Grupo', value: 'tipo_grupo', align: 'center', sortable: false },
          { text: 'Ação Análise de Crédito', value: 'acoes_analise_credito', align: 'center', sortable: false }
        ],
        params: {
          pagination: {
            page: 1,
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'id_cadastro',
            descending: false
          }
        },
        filtro: {
          email_destinatario: '',
          tipo_grupo: [],
          acao_analise_credito: []
        },
        custom_filter: {}
      }
    },
    watch: {
      atualizaListagem () {
        this.filtrar()
      }
    },
    methods: {
      filtrar () {
        this.custom_filter = { ...this.filtro }
      },
      resetFilter () {
        this.filtro = {
          email_destinatario: '',
          tipo_grupo: [],
          acao_analise_credito: []
        }
        this.custom_filter = {}
      },
      editar (item) {
        const tiposGrupo = this.convertNumeroParaStringConstante(item.tipo_grupo)
        const acoesAnalise = this.convertStringToArray(item.acoes_analise_credito)

        const itemParaEdicao = {
          id_cadastro: item.id_cadastro,
          email_destinatario: item.email_destinatario,
          tipo_grupo: tiposGrupo,
          acoes_analise_credito: acoesAnalise
        }

        this.$emit('editar', itemParaEdicao)
      },
      async excluir (id) {
        await this.$http.delete(`/painel/excluir/email-analise-credito/${id}`).then(() => {
          notification(AlertTypes.SUCCESS, 'Registro excluído com sucesso!')
        }).catch((error) => {
          console.error('Erro na exclusão:', error)
          const errorMessage = 'Não foi possível excluir o registro no momento. Tente novamente mais tarde.'
          notification(AlertTypes.ERROR, errorMessage)
        })
        this.filtrar()
      },
      confirmExcluir (id) {
        alert({
          text: 'Deseja mesmo excluir esse registro?',
          buttons: {
            'Cancelar': () => {},
            'Confirmar': () => this.excluir(id)
          }
        })
      },

      convertStringToArray (str) {
        if (!str) return []
        return str.split(',').map(item => parseInt(item.trim()))
      },

      convertNumeroParaStringConstante (str) {
        if (!str) return []

        return str.split(',').map(item => {
          const num = parseInt(item.trim())
          switch (num) {
            case 1: return 'Convencional'
            case 2: return 'Pontual'
            case 3: return 'Pra Já'
            default: return item.trim()
          }
        })
      }
    }
  }
</script>

<style>
.tags-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    align-items: center;
    padding: 8px 0;
}

.tipo-grupo-background,
.analise-background {
    background-color: #e0e0e0;
    padding: 8px 12px;
    border-radius: 15px;
    font-size: 14px;
    display: inline-block;
    white-space: nowrap;
    margin: 4px 2px;
}

.tipo-grupo-background {
    background-color: #e0e0e0;
    padding: 8px 12px;
    border-radius: 15px;
    font-size: 14px;
    display: inline-block;
    white-space: nowrap;
    margin: 4px 2px !important;
}

.analise-background {
    background-color: #e0e0e0;
    padding: 8px 12px;
    border-radius: 15px;
    font-size: 14px;
    display: inline-block;
    white-space: nowrap;
    margin: 4px 2px !important;
}
</style>
